import type { SliceI18nManifest } from '@/shared/lib/vsa';
import cs from './locales/cs.json';
import en from './locales/en.json';

const NS = 'columbus-planner';

export const columbusI18nManifest: SliceI18nManifest = {
  owner: 'features/columbus-planner',
  namespaces: [NS],
  resources: {
    cs: { [NS]: cs },
    en: { [NS]: en },
  },
};
